import type { TOptions } from 'i18next'

export interface ErrorObject {
  errorCode: string
  status?: number
  options?: TOptions
}

export enum SessionIdVisibility {
  HIDDEN,
  VISIBLE,
}

export interface SessionIdState {
  visibility: SessionIdVisibility
}

export const CLICKS_TO_REVEAL_SESSION_ID = 5
